export default __webpack_public_path__ + "static/media/no-vacancy.bb3313c2.jpg";